import { render, staticRenderFns } from "./collapsed_assignee_list.vue?vue&type=template&id=8dccc66e&"
import script from "./collapsed_assignee_list.vue?vue&type=script&lang=js&"
export * from "./collapsed_assignee_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports